import axios from 'axios';
import { TokenStorage } from "./TokenStorage"
import { refresh, baseUrl } from '.'

export default () => {  
  axios.interceptors.request.use(
    config => {
        const token = TokenStorage.getTokens()
        if (token && token.accessToken) {
            config.headers['Authorization'] = 'Bearer ' + token.accessToken
        }
        return config;
    },
    error => {
        Promise.reject(error)
  });

  axios.interceptors.response.use(
    (response) => {
    // Return a successful response back to the calling service
    return response
  }, (error) => {

    /*
    // the client error when the access token has expired
    if (error.response.status === 401){
      return new Promise((resolve, reject) => {
        resolve(TokenStorage.isAuthenticated()); 
      }).catch((error) =>{
        console.log("The error was caught")
        return error
      });
    } */
    
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error)
      });
    }

    // Logout user if token refresh didn't work or user is disabled
    const tokens = TokenStorage.getTokens();
    if (error.config.url === `${baseUrl()}/refresh` || error.response.data.error === 'Access token is not expired' || !tokens) {
      return new Promise((resolve, reject) => {
        TokenStorage.clear()
        reject(error)
      });
    }

    // Try request again with new token
    return refresh(tokens!)
      .then((token) => {
        // New request with new token
        const config = error.config;
        config.headers['Authorization'] = `Bearer ${token}`
        return new Promise((resolve, reject) => {
          axios.request(config).then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        });

      })
  });
}
